import(/* webpackMode: "eager" */ "/vercel/path0/src/app/customer/forgot-password/page.js");
